/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import AkReturnIcon from '@atlaskit/icon-lab/core/return';
import { Box } from '@atlaskit/primitives/compiled/box';
import Tile from '@atlaskit/tile/tile';
import type { TileProps } from '@atlaskit/tile/types';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	base: {
		color: token('color.text.subtle'),
	},
});

export const ReturnIcon = ({
	size = 'small',
	label = '',
}: {
	size?: TileProps['size'];
	label?: string;
}): React.JSX.Element => (
	<Box xcss={styles.base}>
		<Tile label="" size={size}>
			<AkReturnIcon label={label} />
		</Tile>
	</Box>
);
